import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Useful from './views/Useful.vue'
import Actual from './views/Actual.vue'
import References from './views/References.vue'
import Login from './views/Login.vue'
import Admin from './views/Admin.vue'
import firebase from "firebase/app";
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/useful',
      name: 'useful',
      component: Useful
    },
    {
      path: '/actual',
      name: 'actual',
      component: Actual
    },
    {
      path: '/references',
      name: 'references',
      component: References
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  
const currentUser = firebase.auth().currentUser;
const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

if (requiresAuth && !currentUser) 
{ 
  next('/login')
} 
else if (to.path == '/login' && currentUser) 
{ 
  next('/admin')
} else {
  next();
}
})

export default router;
